import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, IconButton, Paper, Popper, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useGuideShown } from '../shared/GuideCallout';

export default function WatchlistPendingCallout({ anchorEl, message, onReview, onDismiss }) {
    const open = Boolean(message && anchorEl);
    useGuideShown(open);
    return (
        <Popper open={open} anchorEl={anchorEl} placement="bottom-end"
            modifiers={[{ name: 'offset', options: { offset: [0, 12] } }]}
            sx={{ zIndex: 1301 }}>
            <Paper role="dialog" aria-label="Pending Watchlist change" elevation={6}
                sx={{ p: 2, width: 310, maxWidth: 'calc(100vw - 24px)', borderRadius: 2,
                    border: '1px solid', borderColor: 'primary.main', position: 'relative',
                    '&::before': { content: '""', position: 'absolute', top: -7, right: 12,
                        width: 12, height: 12, bgcolor: 'background.paper', transform: 'rotate(45deg)',
                        borderLeft: '1px solid', borderTop: '1px solid', borderColor: 'primary.main' } }}>
                <Box display="flex" alignItems="flex-start" gap={1}>
                    <Typography variant="body2" role="status">{message}</Typography>
                    <IconButton size="small" aria-label="Dismiss pending change guidance" onClick={onDismiss}>
                        <CloseIcon fontSize="small" />
                    </IconButton>
                </Box>
                <Button onClick={onReview} sx={{ mt: 1 }}>Review change</Button>
            </Paper>
        </Popper>
    );
}

WatchlistPendingCallout.propTypes = {
    anchorEl: PropTypes.object, message: PropTypes.string,
    onReview: PropTypes.func.isRequired, onDismiss: PropTypes.func.isRequired,
};
